import * as path from "node:path";
import { checkHasProjectFile } from "@prismicio/plugin-kit/fs";
async function buildSrcPath(args) {
  const hasAppDirectory = await checkHasProjectFile({
    filename: "app",
    helpers: args.helpers
  });
  if (hasAppDirectory) {
    return path.join("app", args.filename);
  }
  const hasSrcDirectory = await checkHasProjectFile({
    filename: "src",
    helpers: args.helpers
  });
  if (hasSrcDirectory) {
    return path.join("src", args.filename);
  }
  return args.filename;
}
export {
  buildSrcPath
};
//# sourceMappingURL=buildSrcPath.js.map
